var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 16,
    height: 15,
    rx: 2,
    stroke: "#109C72",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#109C72",
    strokeWidth: 2,
    d: "M5 0v6m8-6v6"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB4PSIxIiB5PSIzIiB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHJ4PSIyIiBzdHJva2U9IiMxMDlDNzIiIHN0cm9rZS13aWR0aD0iMiIvPjxwYXRoIHN0cm9rZT0iIzEwOUM3MiIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNNSAwdjZNMTMgMHY2Ii8+PC9zdmc+";
export { SvgIconCalendar as ReactComponent };